import { Box } from 'native-base';
import React, { useCallback, useEffect, useState } from 'react';
import { VolunteerReenrollmentForm } from '../../components/auth/VolunteerReenrollmentForm';
import { AppStackScreenWithNavProps } from '../../navigation/AppNavigation';
import { useAppDispatch, useAppSelector } from '../../store';
import { registrationActions } from '../../store/actions';
import { VolunteerReenrollmentData } from '../../store/registration/types';
import { nativeAlert } from '../../utils/ui';

export const VolunteerReenrollmentScreen: React.FC<AppStackScreenWithNavProps<'VolunteerReenrollment'>> = ({
  navigation,
}) => {
  const dispatch = useAppDispatch();

  const { error: registrationError } = useAppSelector((state) => state.registrations);

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (registrationError) {
      dispatch(registrationActions.updateError({ error: null }));
      nativeAlert('Enrollment Unsuccessful', registrationError);
    }
  }, [registrationError]);

  const handleSubmit = useCallback(async (data: VolunteerReenrollmentData) => {
    setLoading(true);
    setDisabled(true);

    try {
      await dispatch(registrationActions.submitReenrollment({ data })).unwrap();
      await nativeAlert('Success!', 'Your re-enrollment has been submitted.');
      navigation.goBack();
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  }, []);

  return (
    <Box flex={1}>
      <VolunteerReenrollmentForm loading={loading} disabled={disabled} onSubmit={(data) => handleSubmit(data)} />
    </Box>
  );
};
